import {
  Component,
  OnInit,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
  EventEmitter,
  ViewChild,
  OnDestroy,
} from '@angular/core'
import { CheckoutService } from '../../checkout.service'
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { ElementRef } from '@angular/core'
import { Observable, Subscription } from 'rxjs'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  standalone: false,
  selector: 'vs-shipment-method',
  templateUrl: './shipment-method.component.html',
  styleUrls: ['./shipment-method.component.scss'],
})
export class ShipmentMethodComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isProceedToCheckout: boolean
  @ViewChild('shipmentMethodError', { read: ElementRef, static: false })
  public shipmentMethodError: ElementRef
  @ViewChild('freightAccNoError', { read: ElementRef, static: false })
  public freightAccNoError: ElementRef
  @ViewChild('shipingInstructionsError', { read: ElementRef, static: false })
  public shipingInstructionsError: ElementRef
  @Output() tranportaionData = new EventEmitter<any>()

  public freightTerms = ['Collect', 'Prepaid & Add', '3rd party']
  public hideTextArea: boolean
  public specialInst: Array<any> = []
  incoTermsArray: any
  shipmentListArray: any
  freightTermsArray: any
  selectedINCOTerm: any
  myGroupShipment: FormGroup
  shipmentMethodSelected: any
  freightTermsSelected = false
  shipingInstructions: any = ''
  shipingInstrctn: any = ''
  shipingMarks: any = ''
  freightAccountNumber: any = ''
  specialInstructionData: any
  selectElementText: any
  isConsolidatedShipment: boolean
  retainShipmentMethod = null
  retainCarrier = null
  shippmentMethodObj: any
  cartId: any
  incotermSelected: any
  spcialInsOthers: any
  specailInsOthersRetain: any
  shipmentMedthodRatined: any
  quoteCartType: any
  isMatchFound: any

  public consolidateObj

  public transportionCheck: any = 'Prepay & ADD'
  showShip: void
  sendOrderShip: any
  sendOrderShipMarks: any
  specialInstructionDataObj: any
  displayFreightAccountNumber: boolean = false
  activeCartIdSubscription: Subscription
  activeCartServiceForShipmentMethod: Subscription
  activeCartServiceForIncoTerms: Subscription
  activeCartServiceForSpecialInstruction: Subscription

  constructor(
    private checkoutService: CheckoutService,
    private formBuilder: FormBuilder,
    public activeCartService: ActiveCartFacade,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnDestroy(): void {
    if (this.activeCartIdSubscription) {
      this.activeCartIdSubscription?.unsubscribe()
    }
    if (this.activeCartServiceForShipmentMethod) {
      this.activeCartServiceForShipmentMethod?.unsubscribe()
    }
    if (this.activeCartServiceForSpecialInstruction) {
      this.activeCartServiceForSpecialInstruction?.unsubscribe()
    }
    if (this.activeCartServiceForIncoTerms) {
      this.activeCartServiceForIncoTerms?.unsubscribe()
    }
  }

  ngOnInit(): void {        
    this.preCalls()
    let allowedTypes = ['partial', 'merge', 'full'];
    this.quoteCartType = sessionStorage.getItem('quoteCartType').toLowerCase();
    this.isMatchFound = allowedTypes.filter((item)=>{ return this.quoteCartType.includes(item) });

    this.myGroupShipment.valueChanges.subscribe(
      (data) => {
        this.checkoutService.sendShipmentdataForm(this.myGroupShipment.valid)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.checkoutService.orderpreferences.subscribe(
      (data) => {
        this.shippmentMethodObj = data

        this.myGroupShipment.controls['shipmentMethodSelect'].setValue(
          this.shippmentMethodObj.shipmentMethodCode
        )
        this.checkoutService.shipmentMethodData.next(
          this.myGroupShipment.controls['shipmentMethodSelect'].value
        )

        if (this.shippmentMethodObj.incoTermsCode !== undefined) {
          this.myGroupShipment.controls['incoTerms'].setValue(
            this.shippmentMethodObj.incoTermsCode
          )
          this.onIncoTermsSelect(this.shippmentMethodObj.incoTermsCode, false)
        } else {
          this.myGroupShipment.controls['incoTerms'].setValue('FCA')
          this.onIncoTermsSelect('FCA', false)
        }

        if (this.shippmentMethodObj.freightTermCode !== undefined) {
          this.myGroupShipment.controls['freightTermsSelect'].setValue(
            this.shippmentMethodObj.freightTermCode
          )
        } else {
          this.myGroupShipment.controls['freightTermsSelect'].setValue(
            'Collect'
          )
        }

        this.myGroupShipment.controls['shipingInstrctn'].setValue(
          this.shippmentMethodObj.shipInstructions
        )
        this.checkoutService.sendShipDetails(
          this.shippmentMethodObj.shipInstructions
        )

        this.myGroupShipment.controls['shipingMarks'].setValue(
          this.shippmentMethodObj.shippingMarks
        )
        this.checkoutService.sendShipMarksDetails(
          this.shippmentMethodObj.shippingMarks
        )

        this.myGroupShipment.controls['shipingInstructions'].setValue(
          this.shippmentMethodObj.specialInstructionText
        )
        this.specailInsOthersRetain =
          this.shippmentMethodObj.specialInstructionText

        this.myGroupShipment.controls['freightAccountNumber'].setValue(
          this.shippmentMethodObj.freightAccountNumber
        )

        this.updateFreightAccountNumber(
          this.shippmentMethodObj.freightAccountNumber
        )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.checkoutService.shippinginstructions.subscribe(
      (data) => {
        this.specialInstructionDataObj = data['specialInstructionsList']
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    // this.checkoutService.podetails.subscribe((data) => {});
  }

  preCalls() {
    this.hideTextArea = false
    this.myGroupShipment = this.formBuilder.group({
      shipmentMethodSelect: new FormControl('', Validators.required),
      incoTerms: new FormControl(''),
      freightAccountNumber: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.pattern('^[0-9]*$'), Validators.maxLength(10)],
      }),
      shipingInstrctn: new FormControl(''),
      shipingInstructions: new FormControl('', { updateOn: 'blur' }),
      shipingMarks: new FormControl(''),
      freightTermsSelect: new FormControl(''),
    })

    this.activeCartIdSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe(
        (success) => {
          this.cartId = success
          this.getCart()
          this.fetchIncoTerms()
          this.fetchShipmentMethod()
          this.fetchSpecialInstructionData()
          this.fetchFreightTerms('FCA', false)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  getCart() {
    this.checkoutService.getCartServerResponse.subscribe(
      (success) => {
        this.consolidateObj = success
        this.isConsolidatedShipment =
          this.consolidateObj?.isConsolidatedShipment
      },
      (error) => {}
    )
  }

  ngOnChanges(changes: SimpleChanges): void {}

  get formControls() {
    return this.myGroupShipment.controls
  }

  checkValidateTextArea() {
    if (this.hideTextArea) {
      if (
        this.myGroupShipment.controls['shipingInstructions'] !== null &&
        this.myGroupShipment.controls['shipingInstructions'].value !== null &&
        this.myGroupShipment.controls['shipingInstructions'].value.length > 0
      ) {
        this.checkoutService.carrierDataForm.next(true)
      } else {
        this.checkoutService.carrierDataForm.next(false)
      }
    }
  }

  proceedToReview() {
    if (this.myGroupShipment.invalid) {
      return false
    }
  }

  fetchIncoTerms() {
    this.activeCartServiceForIncoTerms = this.activeCartService
      .getActiveCartId()
      .subscribe((cartId) => {
        if (cartId) {
          this.checkoutService.getIncoTermsCustomer(cartId).subscribe(
            (response) => {
              this.incoTermsArray = response['incoTerms']
              this.checkoutService.iNCOTermsData.next(
                this.myGroupShipment.controls['incoTerms'].value
              )
            },
            (error) => {}
          )
        }
      })
  }

  fetchFreightTerms(incotermSelected: any, manualChange: boolean) {
    this.checkoutService
      .fetchFreightTerms(incotermSelected, this.cartId)
      .subscribe(
        (response) => {
          this.freightTermsArray = response['deliveryModes']

          if (this.freightTermsArray.length == 3) {
            this.freightTermsArray.reverse()
          }

          let finalFTvalue = ''
          if (manualChange) {
            this.myGroupShipment.controls['freightTermsSelect'].setValue(
              this.freightTermsArray[0]?.code
            )
            finalFTvalue = this.freightTermsArray[0]?.code
          } else if (
            !manualChange &&
            this.shippmentMethodObj.freightTermCode !== undefined
          ) {
            this.myGroupShipment.controls['freightTermsSelect'].setValue(
              this.shippmentMethodObj.freightTermCode
            )
            finalFTvalue = this.shippmentMethodObj.freightTermCode
          } else {
            this.myGroupShipment.controls['freightTermsSelect'].setValue(
              this.freightTermsArray[0]?.code
            )
            finalFTvalue = this.freightTermsArray[0]?.code
          }
          this.checkoutService.freightTermsData.next(finalFTvalue)
          //   this.freightTermsArray[0]?.code
          // );

          this.displayFreightAccountNumLogic(
            this.myGroupShipment.controls['freightTermsSelect'].value
          )

          // if (this.freightTermsArray.length > 0) {
          //   this.onFreightTermsSelect(this.freightTermsArray[0].code);
          // }
        },
        (error) => {}
      )
  }

  fetchShipmentMethod() {
    this.activeCartServiceForShipmentMethod = this.activeCartService
      .getActiveCartId()
      .subscribe((cartId) => {
        if (cartId) {
          this.checkoutService.getShipmentMethod(cartId).subscribe(
            (response) => {
              this.shipmentListArray = response['shipmentList'].sort((a, b) =>
                a.value.toLowerCase() > b.value.toLowerCase()
                  ? 1
                  : b.value.toLowerCase() > a.value.toLowerCase()
                  ? -1
                  : 0
              )
            },
            (error) => {}
          )
        }
      })
  }
  fetchSpecialInstructionData() {
    this.activeCartServiceForSpecialInstruction = this.activeCartService
      .getActiveCartId()
      .subscribe((cartId) => {
        if (cartId) {
          this.checkoutService
            .getSpecialInstructionData(cartId)
            .subscribe((response) => {
              this.specialInstructionData = response['specialInstructionsList']

              for (let i = 0; i < this.specialInstructionData.length; i++) {
                if (
                  this.specialInstructionData[i] !== undefined &&
                  (this.specialInstructionData[i].code === 'Others' ||
                    this.specialInstructionData[i].code === 'Other') &&
                  this.specialInstructionData[i].selected
                ) {
                  this.hideTextArea = true
                  this.myGroupShipment.controls['shipingInstructions'].setValue(
                    this.specailInsOthersRetain
                  )
                  break
                }
              }

              for (let i = 0; i < this.specialInstructionData.length; i++) {
                const obj = {
                  code: this.specialInstructionData[i].code,
                  name: this.specialInstructionData[i].name,
                  selected: this.specialInstructionData[i].selected,
                }
                this.assignCheckInstructions(obj, obj.code)
              }
            })
        }
      })
  }

  displayFreightAccountNumLogic(freightTermChosen) {
    this.checkoutService.freightTermsData.next(freightTermChosen)

    if (freightTermChosen === 'Prepay_ADD' || freightTermChosen === '0003') {
      this.displayFreightAccountNumber = false
      this.tranportaionData.emit(true)
      this.checkoutService.freightTermsAccNoData.next('')

      this.myGroupShipment.controls['freightAccountNumber'].reset()
      this.myGroupShipment.controls['freightAccountNumber'].clearValidators()
      this.myGroupShipment.controls['freightAccountNumber'].setValidators(null)
      this.myGroupShipment.controls[
        'freightAccountNumber'
      ].updateValueAndValidity()
      this.myGroupShipment.controls['freightAccountNumber'].setValidators([
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(10),
      ])
    } else if (
      freightTermChosen === 'Collect' ||
      freightTermChosen === '3rd_Party' ||
      freightTermChosen === '0001' ||
      freightTermChosen === '0002'
    ) {
      this.displayFreightAccountNumber = true
      this.tranportaionData.emit(false)

      if (this.shippmentMethodObj.freightAccountNumber === '') {
        this.myGroupShipment.controls['freightAccountNumber'].reset()
      }

      this.myGroupShipment.controls['freightAccountNumber'].setValidators([
        Validators.required,
      ])
      this.myGroupShipment.controls[
        'freightAccountNumber'
      ].updateValueAndValidity()
    }
  }

  onIncoTermsSelect(value: any, manualChange: boolean) {
    this.selectedINCOTerm = value
    this.checkoutService.iNCOTermsData.next(value)
    this.fetchFreightTerms(this.selectedINCOTerm, manualChange)
  }

  updateCheckedOptions(event, selectedValue) {
    if (selectedValue === 'Others' || selectedValue === 'Other') {
      this.myGroupShipment.controls['shipingInstructions'].reset()
      if (event.target.checked) {
        this.hideTextArea = true
      } else {
        this.myGroupShipment.controls['shipingInstructions'].setErrors(null)
        this.hideTextArea = false
        this.checkoutService.sendShipmentdataForm(this.myGroupShipment.valid)
      }
    }
    this.captureData(event, selectedValue)
  }

  assignCheckInstructions(obj, objcode) {
    switch (
      objcode !== '' &&
      objcode !== undefined &&
      objcode !== null &&
      objcode.toLowerCase()
    ) {
      case 'special documentation':
        this.checkoutService.specialdocSIData.next(obj)
        break
      case 'final test report':
        this.checkoutService.finaltestSIData.next(obj)
        break
      case 'valves dimensional drawing acceptance':
        this.checkoutService.valvesdimenSIData.next(obj)
        break
      case 'other':
        this.checkoutService.othersSIData.next(obj)
        break
      case 'others':
        this.checkoutService.othersSIData.next(obj)
        break
      case 'inspection & testing requirements':
        this.checkoutService.inspectionTestSIData.next(obj)
        break
      case 'cmtrs':
        this.checkoutService.cMTRSSIData.next(obj)
        break
      case 'instruction manuals':
        this.checkoutService.iNstructionSIData.next(obj)
        break
      case 'witness inspection':
        this.checkoutService.witnessInspctnData.next(obj)
        break
      case 'bank guarantee':
        this.checkoutService.bankGuaranteeData.next(obj)
        break
      case 'certificate of origin':
        this.checkoutService.certificateOriginData.next(obj)
        break
      case 'coo w/chamber of comm stamp':
        this.checkoutService.cooStampData.next(obj)
        break
      case 'certificate of conformance':
        this.checkoutService.certificateConformanceData.next(obj)
        break
      case 'certificate of manufacture':
        this.checkoutService.certificateManufactureData.next(obj)
        break
      case 'warranty certificate':
        this.checkoutService.warrantyCertificateData.next(obj)
        break
    }
  }

  captureData(event, selected) {
    const obj = {
      code: event.target.id,
      name: selected,
      selected: event.target.checked,
    }
    this.assignCheckInstructions(obj, obj.code)
  }

  onShipmentListSelect(value: any) {
    this.checkoutService.shipmentMethodData.next(value)
  }

  onFreightTermsSelect(value: any) {
    this.checkoutService.freightTermsData.next(value)
  }

  onshipingInstrctn(value: any) {
    this.sendOrderShip = value
    this.checkoutService.sendShipDetails(this.sendOrderShip)
    this.checkoutService.shipingInstrctnData.next(this.sendOrderShip)
  }
  onshipingInstructions(value: any) {
    this.spcialInsOthers = value
    this.checkoutService.specailInsOthers(this.spcialInsOthers)
    this.checkoutService.shipingInstructionsData.next(value)
  }

  onshipingMarks(value: any){
    this.sendOrderShipMarks = value
    this.checkoutService.sendShipMarksDetails(this.sendOrderShipMarks)
    this.checkoutService.shipingMarksData.next(this.sendOrderShipMarks)
  }

  updateFreightAccountNumber(value) {
    if (
      this.myGroupShipment.controls['freightTermsSelect'].value ===
        'Prepay_ADD' ||
      this.myGroupShipment.controls['freightTermsSelect'].value === '0003'
    ) {
      this.checkoutService.freightTermsAccNoData.next('')
    } else {
      this.checkoutService.freightTermsAccNoData.next(value)
    }
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true })
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control)
      }
    })
  }
}
